import { useCurrentUserContext } from '#src/contexts/currentUser/index.ts';

import { WalletTab } from './index.tsx';

const backButtonDestinations = {
  [WalletTab.RECOVER_KEY]: null,
  [WalletTab.RESTORE_WALLET]: WalletTab.HOME,
  [WalletTab.GENERATE_KEYS]: null,
  [WalletTab.CHANGE_PASSWORD]: null,
  [WalletTab.GET_PASSWORD]: null,
  [WalletTab.HOME]: null,
  [WalletTab.SETTINGS]: WalletTab.HOME,
  [WalletTab.PRIVATE_KEY_EXPORT]: WalletTab.SETTINGS,
  [WalletTab.SOLANA_PRIVATE_KEY_EXPORT]: WalletTab.SETTINGS,
  [WalletTab.STARKWARE_CARDS]: WalletTab.SETTINGS,
  [WalletTab.DEPOSIT]: WalletTab.SETTINGS,
  [WalletTab.ADD_FUNDS]: WalletTab.HOME,
  [WalletTab.ADD_FUNDS_TO_FIAT_WALLET]: WalletTab.ADD_FUNDS,
  [WalletTab.ADD_FUNDS_TO_FIAT_WALLET_SUCCEEDED]: WalletTab.HOME,
  [WalletTab.ADD_FUNDS_TO_FIAT_WALLET_SUCCEEDED_WITH_PROMO]: WalletTab.HOME,
  [WalletTab.ADD_FUNDS_TO_FIAT_WALLET_REVIEW]:
    WalletTab.ADD_FUNDS_TO_FIAT_WALLET,
  [WalletTab.ADD_FUNDS_TO_CRYPTO_WALLET]: WalletTab.ADD_FUNDS,
  [WalletTab.WITHDRAW_TO]: WalletTab.HOME,
  [WalletTab.WITHDRAW_TO_CRYPTO_WALLET]: WalletTab.WITHDRAW_TO,
  [WalletTab.WITHDRAW_TO_FIAT_WALLET]: WalletTab.WITHDRAW_TO,
  [WalletTab.WITHDRAW_TO_FIAT_WALLET_REVIEW]: WalletTab.WITHDRAW_TO_FIAT_WALLET,
  [WalletTab.WITHDRAW_TO_FIAT_WALLET_SUCCESS]: WalletTab.HOME,
  [WalletTab.WITHDRAW_TO_FIAT_WALLET_ADD_BANK_ACCOUNT]:
    WalletTab.WITHDRAW_TO_FIAT_WALLET,
  [WalletTab.CONVERT_TO_EUR]: WalletTab.HOME,
  [WalletTab.CONVERT_TO_EUR_SUCCESS]: WalletTab.HOME,
};

export const useBackButtonDestinations = () => {
  const {
    walletPreferences: { showCryptoWallet, showFiatWallet },
  } = useCurrentUserContext();

  return {
    ...backButtonDestinations,
    ...(showFiatWallet &&
      !showCryptoWallet && {
        [WalletTab.ADD_FUNDS_TO_FIAT_WALLET]: WalletTab.HOME,
        [WalletTab.WITHDRAW_TO_FIAT_WALLET]: WalletTab.HOME,
      }),
    ...(showCryptoWallet &&
      !showFiatWallet && {
        [WalletTab.ADD_FUNDS_TO_CRYPTO_WALLET]: WalletTab.HOME,
        [WalletTab.WITHDRAW_TO_CRYPTO_WALLET]: WalletTab.HOME,
      }),
  };
};
